import { useMemo } from "react";
import "./upgradeStepper.css";

export default function CustomStepper({
  currentStep = 3,
  style,
  isKycProcessCompleted,
}) {
  const all_steps = [
    "Choose plan",
    "Configure",
    "Billing",
    "Verification",
    "Review & Pay",
  ];

  const steps = useMemo(
    () =>
      isKycProcessCompleted
        ? all_steps.filter((step) => step != "Verification")
        : all_steps,
    [isKycProcessCompleted],
  );

  return (
    <div className="stepper" style={style}>
      {steps.map((step, index) => {
        const stepIndex = index + 1;

        return (
          <div key={step} className="step">
            <p
              className={`label   
                        ${stepIndex !== currentStep && stepIndex > currentStep && "inactive"}`}
            >
              {step}
            </p>

            <div className="bar">
              <div
                className={`progress 
                                ${stepIndex === currentStep && "inactive"}
                                ${stepIndex < currentStep && "active"}`}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
